<template>
  <MPopoverNotificationList>
    <MPopoverNotification
      v-for="item in items"
      :key="item.id"
      :alert-type="item.type"
      @close="dismiss(item.id)"
    >
      <component
        :is="item.bodyComponent"
        v-if="item.bodyComponent"
        v-bind="item.bodyProps"
      />
      <template v-else-if="!!item.text">{{ item.text }}</template>
    </MPopoverNotification>
  </MPopoverNotificationList>
</template>

<script lang="ts">
import { v4 as uuidv4 } from 'uuid'
import { defineComponent } from 'vue'

import { usePopover } from '../../../composables/usePopover'
import { AddParams } from '../../../composables/usePopover'

import MPopoverNotification from './MPopoverNotification.ts.vue'
import MPopoverNotificationList from './MPopoverNotificationList.ts.vue'

interface PopoverListItems extends AddParams {
  id: string
}

/**
 * UI for the global popover composable
 */
export default defineComponent({
  name: 'MPopoverNotificationContainer',
  components: {
    MPopoverNotificationList,
    MPopoverNotification,
  },
  emits: ['dismiss'],
  setup() {
    const { popoverState } = usePopover()

    return {
      popoverState,
    }
  },
  data(): { items: PopoverListItems[] } {
    return {
      items: [],
    }
  },
  watch: {
    popoverState: {
      handler: function (newVal: AddParams) {
        this.add(newVal)
      },
      deep: true,
    },
  },
  methods: {
    add(params: AddParams): void {
      const isMaxAlerts = this.items.length > 5
      if (isMaxAlerts) {
        this.items.splice(0, 1)
      }

      const id = uuidv4()
      this.items.push({
        id,
        ...params,
      })
    },
    dismiss(id: string): void {
      const index = this.items.map((i) => i.id).indexOf(id)
      this.$emit('dismiss', this.items[index])
      this.items.splice(index, 1)
    },
  },
})
</script>
